import { mapState } from "vuex";

const minin = {
  data() {
    return {
      viewMode: false,
      labelWidth: '180px',
      form: {},
      formCtrl: [],
      getOptionUrl: 'addpro',
      getDataUrl: 'item',
      submitUrl: 'addedu',
      mode: '',
      detail: {},
      rules: {
        inton: [
          { validator: this.checkTon, trigger: "blur" },
        ],
        unton: [
          { validator: this.checkTon, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  methods: {
    setCtrlOption(v, team, key1, key2) {
      team.map(c => {
        v.options.push({
          label: c[key1 || 'name'],
          value: c[key2 || 'id'],
        })
      })
    },
    checkTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      // if (value == undefined || value == '') {
      //   callback(new Error('请确认密码'));
      // } else
      // if (Number(value) > 3000) {
      //   callback(new Error('重量不能超过3000吨'));
      // } else {
        callback();
      // }
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (['identitycard', 'driverslicense', 'certificate', 'escortcard'].includes(key) || key.includes('photo') || (value && typeof value === 'object')) {
        this.form[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
        // } else if (['inton', 'unton'].includes(key) && Number(value) > 60) {
        // this.$message({
        //   type: 'error',
        //   message: '重量不能大于60吨',
        // });
        // return
      } else {
        this.form[key] = value;
      }
      // console.log({ ...this.form });
    },
    formOrtherValidate() {
      return true
    },
    onSubmit() {
      console.log({ ...this.form });
      const boo = this.formOrtherValidate()
      // console.log(boo)
      const validate = this.$refs['form'].validate
      const validatePass = this.$refs['form'].validatePass
      // console.log(this.$refs['form']);
      // console.log(validatePass);
      if (boo && validate) {
        validate((valid) => {
          // console.log(valid)
          if (valid) {
            this.submitConfirm()
          } else {
            console.log('验证不通过');
            console.log({ ...this.form })
            this.$message({
              type: 'error',
              message: '请修改错误信息',
            });
            return false;
          }
        });
      } else if (boo && validatePass) {
        validatePass(() => {
          this.submitConfirm()
        });
      }
    },
    submitConfirm() {
      if (this.loading) {
        this.$message({
          type: 'warning',
          message: '请不要连续重复提交!',
        });
        return
      }
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      // if (this.loading) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请不要连续重复提交!',
      //   });
      //   return
      // }

      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      
      this.paramsPackage(params, this.form)
      // 最后的id赋值必须在最后，不然会传错id
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }

      console.log(url, params)
      
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
        this.loading = false
      })
    },
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
    },

    /**
     * // 操作类型映射
      protected $methodMap = [
          'create' => '创建',
          'update' => '修改',
          'delete' => '删除',
          'review' => '审核',
          'reject' => '驳回'
      ];

      // 模块名称映射
      protected $moduleMap = [
          'order'                 => '普通订单',
          'contract_order'        => '合同订单',
          'order_compensation'    => '订单补差',
          'contract'              => '合同管理',
          'contract_compensation' => '合同补差',
          'custom'                => '客户列表',
          'carrier'               => '承运人管理',
          'car'                   => '车辆列表',
          'hire_car'              => '雇佣车辆',
          'trailer'               => '挂车管理',
          'fleet_group'           => '车队分组',
          'violation'             => '违章管理',
          'maintenance'           => '维保列表',
          'repair_shop'           => '维修商管理',
          'staff'                 => '人员管理',
          'reimburse'             => '报销管理',
          'receivable'            => '应收账款管理',
          'payable'               => '应付账款管理',
          'fixed_expense'         => '固定费用支出表',
          'trip_expense'          => '出车费用表',
          'fleet_profit'          => '车队利润表',
          'fleet_manager_salary'  => '车队长工资表',
      ];
     */

    cancel() {
      this.$router.back();
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/${this.getDataUrl}`;
      const params = {
        userid: this.user.id,
        id: this.id,
      }
      this.post(url, params, (res) => {
        const { msg, data } = res
        if (msg === 'success' && data) {
          this.detail = data
          this.setDetailOrderData(res)
          this.setDetail()
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setDetail() {
      this.formCtrl.map(v => {
        const key = v.keyName
        this.form[key] = this.detail[key];
      })
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    setDetailOrderData() { },
    getOptions(params = {}) {
      this.post(`${this.baseUrl}/${this.getOptionUrl}`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions() { },
  },
  created() {
    // console.log(this.$route.query);
    const object = this.$route.query
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        this[key] = object[key];
      }
    }
    const { id, mode } = object;
    // console.log(mode)
    if (id) {
      this.id = id
    }
    const b = this.breadcrumb
    this.mode = mode
    if (mode === 'view') {
      this.viewMode = true
      if (b && b[2]) {
        const n = b[2].name
        // console.log(n)
        if (n.includes('编辑')) {
          b[2].name = n.replace('编辑', '查看')
        } else {
          b[2].name = n.replace('添加', '查看')
        }
      }
    } else if (mode === 'edit') {
      if (b && b[2]) {
        const n = b[2].name
        // console.log(n)
        b[2].name = n.replace('添加', '编辑')
      }
    }
  },
  mounted() {
    if (this.id) this.getData();
  },
}

export default minin